<template>
  <div class="talk-part">
    <div class="zan-cai-date clearfix">
      <!--   作品本身-->
      <div class="zan-cai" v-if="objSelf">
        <div
          class="item"
          :class="{ active: talkOBJ.likeFlag }"
          v-on:click="likeEvent(talkOBJ.id,talkOBJ.belongSection)"
        >
          <span class="zc-icon zan "></span>
          <span class="count">{{ talkOBJ.likeCount }}</span>
        </div>
        <div
          class="item"
          v-if="objType != 3"
          :class="{ active: talkOBJ.disLikeFlag }"
          v-on:click="disLikeEvent(talkOBJ.id,talkOBJ.belongSection)"
        >
          <span class="zc-icon cai"></span>
          <span class="count">{{ talkOBJ.dislikeCount }}</span>
        </div>
        <div class="item" v-if="objType != 3" @click="pinglunEvent">
          <span class="zc-icon pinglun"></span>
          <span class="count">{{ talkOBJ.commentCount }}</span>
        </div>
        <div
          class="item"
          :class="{ active: talkOBJ.shareCount > 0 ? true : false }"
          @click="share"
        >
          <span class="zc-icon zhuanfa"></span>
          <span class="count">{{ talkOBJ.shareCount }}</span>
        </div>
        <div
          class="item more"
          v-if="!isProView && objType != 3 && !isAdvertising"
        >
          <el-dropdown>
            <span class="el-dropdown-link count"
              ><i class="el-icon-more"></i
            ></span>
            <el-dropdown-menu slot="dropdown">
              <span
                v-on:click="jubao(talkOBJ.id)"
                v-if="notifyType == 1 || notifyType == 2"
                ><el-dropdown-item>举报</el-dropdown-item></span
              >
              <span v-on:click="commitCollect(talkOBJ.id)" v-if="objType != 3"
                ><el-dropdown-item>收藏</el-dropdown-item></span
              >
              <span
                v-on:click="toDetail(talkOBJ.id)"
                v-if="isLogin && talkOBJ.creatorId == loginUserId"
                ><el-dropdown-item>编辑</el-dropdown-item></span
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!--交互行为-->
      <div class="zan-cai" v-else>
        <div
          class="item"
          :class="{ active: notify.likeFlag }"
          v-on:click="likeEvent(notify.id,notify.belongSection)"
        >
          <span class="zc-icon zan "></span>
          <span class="count">{{ notify.likeCount }}</span>
        </div>
        <div
          class="item"
          :class="{ active: notify.disLikeFlag }"
          v-on:click="disLikeEvent(notify.id,notify.belongSection)"
        >
          <span class="zc-icon cai"></span>
          <span class="count">{{ notify.dislikeCount }}</span>
        </div>
        <div class="item" @click="pinglunEvent">
          <span class="zc-icon pinglun"></span>
          <span class="count">{{ notify.commentCount }}</span>
        </div>
        <div class="item" :class="{ active: notify.shareFlag }" @click="share">
          <span class="zc-icon zhuanfa"></span>
          <span class="count">{{ notify.shareCount }}</span>
        </div>
        <div class="item more" v-if="!isProView && !isAdvertising">
          <el-dropdown>
            <span class="el-dropdown-link count"
              ><i class="el-icon-more"></i
            ></span>
            <el-dropdown-menu slot="dropdown">
              <span
                v-on:click="jubao(talkOBJ.id)"
                v-if="notifyType == 1 || notifyType == 2"
                ><el-dropdown-item>举报</el-dropdown-item></span
              >
              <span v-on:click="commitCollect(talkOBJ.id)" v-if="objType != 3"
                ><el-dropdown-item>收藏</el-dropdown-item></span
              >
              <span
                v-on:click="toDetail(talkOBJ.id)"
                v-if="isLogin && talkOBJ.creatorId == loginUserId"
                ><el-dropdown-item>编辑</el-dropdown-item></span
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="date">{{ notify.ts | formatTime }}</div>
    </div>

    <!-- 赞和分享列表 -->
    <div>
      <div v-if="likeCountNum > 0" class="zan-list">
        <div class="show-zan clearfix" @click="dropList">
          <i class="zan-icon zan"></i>
          <span class="z-tip">{{ likeCountNum }}人已点赞</span>
          <i class="el-icon-arrow-down show-list-arrow" v-if="showLike"></i>
          <i class="el-icon-arrow-right show-list-arrow" v-if="!showLike"></i>
        </div>
        <div class="user-list" v-if="showLike">
          <a class="user" v-for="(user, index) in userListLike" :key="index">
            <router-link
              target="_blank"
              :to="{ path: '/home', query: { userId: user.userId } }"
              >{{ user.userName }}
            </router-link>
          </a>
          <i
            class="el-icon-more"
            @click="showAllUser"
            v-if="showMore"
            style="cursor: pointer"
          ></i>
        </div>
      </div>
      <div v-if="userListShare.length > 0" class="zan-list">
        <div class="show-zan clearfix" @click="dropList1">
          <i class="zan-icon fen"></i>
          <span class="z-tip">{{ userListShare.length }}人已分享</span>
          <i class="el-icon-arrow-down show-list-arrow" v-if="showShare"></i>
          <i class="el-icon-arrow-right show-list-arrow" v-if="!showShare"></i>
        </div>
        <div class="user-list" v-if="showShare">
          <a
            class="user"
            target="_blank"
            v-for="(user, index) in userListShare"
            :key="index"
          >
            <router-link
              target="_blank"
              :to="{ path: '/home', query: { userId: user.userId } }"
              >{{ user.userName }}
            </router-link>
          </a>
          <i
            class="el-icon-more"
            @click="showAllUser"
            v-if="showMore"
            style="cursor: pointer"
          ></i>
        </div>
      </div>
    </div>

    <!--父级评论-->
    <ul v-if="commentTotal > 0" class="home-pinglun-list">
      <li v-for="(item, index) in commentListDate" :key="index">
        <router-link
          class="user"
          :to="{ path: '/home', query: { userId: item.commentAuthor } }"
          >{{ item.commentAuthorName }}</router-link
        >
        ：<div v-html="item.commentContent" ></div>
      </li>

      <li v-if="commentShowMore" @click="getFather" class="show-all">
        查看更多评论
      </li>
    </ul>

    <template v-if="showFirPL">
      <div class="time-paixu">
        <!--        <span><i class="el-icon-sort"></i>时间排序</span>-->
      </div>
      <el-form :model="formFather" ref="formFather" v-if="!isProView">
        <div class="console-ipt">
          <el-input
            class="textarea"
            type="textarea"
            :rows="1"
            placeholder="请输入内容"
            v-model="formFather.commentContent"
          >
          </el-input>
          <div class="checked-btn clearfix">
            <!--          <el-checkbox class="checked" v-model="formFather.activitiesAnd">同时转发到我的动态</el-checkbox>-->
            <el-button
              class="fabu-btn"
              type="primary"
              size="mini"
              @click="submitFather()"
              v-if="isLogin"
            >
              发布
            </el-button>
            <el-button
              class="fabu-btn"
              type="primary"
              size="mini"
              @click="toLog"
              v-else
              >请登录</el-button
            >
          </div>
        </div>
      </el-form>

      <!--      commonRankList:[],-->
      <!--      commonSimpleList:[],-->
      <talk-sec
        v-if="objSelf && isReloadV"
        :objId="objId"
        :objType="objType"
        :loadShow="loadShow"
        :commentAuthorRankId="1"
        list-title="专家评论"
        :isProView="isProView"
      ></talk-sec>
      <talk-sec
        v-if="objSelf && isReload"
        :objId="objId"
        :objType="objType"
        :loadShow="loadShow"
        :commentAuthorRankId="0"
        list-title="用户评论"
        :isProView="isProView"
      ></talk-sec>
      <talk-sec
        v-else-if="isReload"
        :objId="nid"
        :objType="commentObjectType"
        :loadShow="loadShow"
        :commentAuthorRankId="0"
        list-title="用户评论"
        :isProView="isProView"
      ></talk-sec>
      <div class="no-more" v-if="!isReloadV && !isReload">暂无评论</div>
    </template>
    <!-- 分享弹窗 -->
    <el-dialog
      title="分享到"
      class="common-dialog"
      :visible.sync="dialogVisibleShare"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      append-to-body
    >
      <ul class="dialog-share-list clearfix">
        <li>
          <div class="img-f" @click="shareMy">
            <img :src="require('@/assets/images/share_01.png')" alt="" />
          </div>
          <p>我的动态</p>
        </li>
        <li @click="shareWechat">
          <div class="img-f">
            <img :src="require('@/assets/images/share_02.png')" alt="" />
          </div>
          <p>微信</p>
        </li>
        <li @click="shareWeibo">
          <div class="img-f">
            <img :src="require('@/assets/images/share_03.png')" alt="" />
          </div>
          <p>微博</p>
        </li>
        <li @click="shareQQzone">
          <div class="img-f">
            <img :src="require('@/assets/images/share_04.png')" alt="" />
          </div>
          <p>QQ空间</p>
        </li>
        <!--                <li @click="sharePoster">-->
        <!--                    <div class="img-f">-->
        <!--                        <img :src="require('@/assets/images/share_05.png')" alt="">-->
        <!--                    </div>-->
        <!--                    <p>生成海报</p>-->
        <!--                </li>-->
        <li @click="copyLink">
          <div class="img-f">
            <img :src="require('@/assets/images/share_06.png')" alt="" />
          </div>
          <p>复制链接</p>
        </li>
        <!-- <li>
                  <div class="img-f">
                    <img :src="require('@/assets/images/share_01.png')" alt="">
                  </div>
                  <p>收藏</p>
                </li> -->
      </ul>
      <el-dialog
        title="分享到微信"
        class="common-dialog"
        :visible.sync="dialogVisibleShareWechat"
        :close-on-click-modal="false"
        append-to-body
      >
        <div ref="qrcode" id="qrcode" class="dialog-share-wechat"></div>
      </el-dialog>

      <el-dialog
        title="扫描生成海报"
        class="common-dialog"
        :visible.sync="dialogVisibleSharePoster"
        :close-on-click-modal="false"
        append-to-body
      >
        <div
          ref="qrcodePoster"
          id="qrcodePoster"
          class="dialog-share-wechat"
        ></div>
      </el-dialog>
    </el-dialog>
    <!-- 举报 -->
    <el-dialog
      title="举报理由"
      class="common-dialog"
      :visible.sync="dialogVisibleJubao"
      :close-on-click-modal="false"
    >
      <div class="dialog-jubao-cont">
        <el-radio-group v-model="jubaolist">
          <el-radio value="1" label="1">侵犯版权</el-radio>
          <el-radio value="2" label="2">内容低俗</el-radio>
          <el-radio value="3" label="3">恶意灌水</el-radio>
          <el-radio value="0" label="0">其他</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-on:click="commitJubao">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import talkSec from '@@/pub/talksec/talksec'
// import QRCode from 'qrcodejs2'
import commentApi from '@/api/comment'
import productionApi from '@/api/production'
import archiveApi from '@/api/archive'
import apiService from '@/api/index'
// import global_ from '@/api/global'

export default {
    components: {
        talkSec
    },
    props: {
        objId: {
            required: true,
            type: Number
        },
        nid: {
            required: true,
            type: Number
        },
        notifyType: {
            required: true,
            type: Number
        },
        objType: {
            required: true,
            type: Number
        },
        loadShow: {
            type: Boolean
        }
        ,
        isProView: {
            type: Boolean
        }

    },
    data() {
        return {
            callbackurl:"",
            commentObjectType: 4,
            isReloadV: true,
            isReload: true,
            isLogin: false,
            showFirPL: false,
            isFirst: true,
            textCon: '',
            disLikeActive: true,
            dialogVisibleShare: false,
            dialogVisibleShareWechat: false,
            dialogVisibleSharePoster: false,
            dialogVisibleJubao: false,
            jubaolist: [],
            loginUserId: 0,
            commonParam1:{
                commentObjectId:this.objId,
                commentObjectType:this.objType,
                commentAuthorRankId:1,//评论者等级id 大于1为专家//0为普通
                commentParent:0,//0为父级评论
                pageIndex: 1,
                pageSize: 2,
            },
            commonParam2:{
                commentObjectId:this.objId,
                commentObjectType:this.objType,
                commentAuthorRankId:0,//评论者等级id 大于1为专家//0为普通
                commentParent:0,//0为父级评论
                pageIndex: 1,
                pageSize: 2,
            },
            commonRankList: [],
            commonSimpleList: [],
            talkOBJ: {},//接受作品对象
            notify: {},//接受通知对象
            formFather:{
                commentObjectId:this.objId,
                commentObjectType:this.objType,
                commentParent:0,//0为父级评论
                commentContent:'',
                commentAuthor:0,
                activitiesAnd: false, //是否动态
            },
            objLink: "",
            shareTitle: "",
            sharePic: "",
            posterUrl: '',
            shareParam:{
                objectType: this.objType,
                objectId: this.objId,
                belongSection:null,
                shareTo: 1,
                time: new Date().getMilliseconds()
            },
            objSelf:false,
            likeCountNum: 0,//点赞和分享列表
            shareCountNum: 0,
            showLike: false,
            showMore: false,
            showShare: false,
            showMore1: false,
            userListLike: [],
            userListShare: [],
            commentShowMore:true,//父级评论
            commentTotal:0,
            commentListDate:[],
            commonParam:{
                commentObjectId:this.objId,
                commentObjectType:this.objType,
                commentAuthorRankId: -1,//评论者等级id 大于1为专家//0为普通 -1q全部
                commentParent:0,//0为父级评论
                pageIndex: 1,
                pageSize: 10,
            },
            isAdvertising:false
        }
    },
  // beforeMount() {
  //   // 只会在浏览器执行Z
  //   const QRCode = () => import('qrcodejs2')
  // },
    mounted() {
        this.callbackurl="login?callback="+window.location.href;
        this.initData();

    },
    methods: {
        initData() {

            let this_ = this
            let objId = this.objId;
            let objType = this.objType;
            let nid = this.nid;
            let notifyType = this.notifyType
            if(notifyType == 1|| notifyType  == 2 || notifyType  == 3 || objType == 3){
                this_.commentObjectType = objType
                this_.commonParam1.commentObjectId = objId
                this_.commonParam1.commentObjectType = objType
                this_.commonParam2.commentObjectId = objId
                this_.commonParam2.commentObjectType = objType
                this_.formFather.commentObjectId = objId
                this_.formFather.commentObjectType = objType
                this_.shareParam.objectType = objType
                this_.shareParam.objectId = objId
                this_.objSelf = true
                this_.commonParam.commentObjectId = objId
                this_.commonParam.commentObjectType = objType
            }else{
                this_.commentObjectType = 4
                this_.commonParam1.commentObjectId = nid
                this_.commonParam1.commentObjectType = 4
                this_.commonParam2.commentObjectId = nid
                this_.commonParam2.commentObjectType = 4
                this_.formFather.commentObjectId = nid
                this_.formFather.commentObjectType = 4
                this_.shareParam.objectType = 4
                this_.shareParam.objectId = nid
                this_.commonParam.commentObjectId = nid
                this_.commonParam.commentObjectType = 4
                this_.objSelf = false

            }
            // console.log("===========isProView=======================",this.isProView)
            // console.log("=================== objType ===============",objType)
            // console.log("=============================isLogin =====",this.global.isLogin)
            if (this.global.isLogin) {
                this_.loginUserId = this.global.userModel.id
                this_.isLogin = true
            }
            let url = "/rrbi/notifications/selectone/" + this_.nid + "?ti=" + new Date().getMilliseconds();
            this_.$axios.get(url).then(function (result) {
                this_.notify = result.data.response;

                if(!this_.objSelf){
                    this_.likeCountNum = this_.notify.likeCount
                    this_.shareCountNum = this_.notify.shareCount
                }

            })
            let uu=["a","b","c","d","e","f","g","h","i","j"]
            let t=(new Date().getTime()+""+new Date().getMilliseconds()).toString().split('');
            let uuid="";
            t.forEach(function (e) {
                uuid=uuid+uu[e]+"";
            })
            if (objType == 1) {
                //作品
                productionApi.select(objId).then(data => {
                    this_.talkOBJ = data.response;
                    if(this_.talkOBJ.productionType == -1){
                        this_.isAdvertising = true
                        // this_.objLink=encodeURIComponent("http://www.renrendonghua.com/worksdetail?id="+ this_.objId);
                        this_.objLink=this_.talkOBJ.link
                        this_.shareTitle="广告分享_"+this_.talkOBJ.productionName;
                        this_.sharePic=this_.talkOBJ.productionCover
                        this_.posterUrl="http://www.renrendonghua.com/postadvertpost/postadvert-v1?id="+ this_.objId+"&tem="+new Date().getMilliseconds();
                    }else{
                        this_.isAdvertising = false
                        // this_.objLink=encodeURIComponent("http://www.renrendonghua.com/worksdetail?id="+ this_.objId);
                        this_.objLink="http://www.renrendonghua.com/worksdetail?id="+ this_.objId;
                        this_.shareTitle="作品分享_"+this_.talkOBJ.productionName;
                        this_.sharePic=this_.talkOBJ.productionCover
                        this_.posterUrl="http://www.renrendonghua.com/postproductionpost/postproduction-v1?id="+ this_.objId+"&tem="+new Date().getMilliseconds();
                    }
                    if(this_.objSelf){
                        this_.likeCountNum = this_.talkOBJ.likeCount
                        this_.shareCountNum = this_.talkOBJ.shareCount
                    }
                })
            } else if (objType == 2) {
                //文章
                archiveApi.select(objId).then(data => {
                    this_.talkOBJ = data.response;
                    this_.objLink = "http://www.renrendonghua.com/column/davdetail?id=" + this_.objId;
                    this_.shareTitle = "文章分享_" + this_.talkOBJ.archiveTitle
                    this_.posterUrl = "http://www.renrendonghua.com/postarticlepost/postarticle-v1?id=" + this_.objId + "&tem=" + new Date().getMilliseconds();
                    this_.sharePic = this_.talkOBJ.thumbnail
                    if(this_.objSelf){
                        this_.likeCountNum = this_.talkOBJ.likeCount
                        this_.shareCountNum = this_.talkOBJ.shareCount
                    }
                })
            } else if (objType == 3) {
                //活动
                let url = "/rrbi/activity/activity-one?id=" + this_.objId + "&ti=" + new Date().getMilliseconds();
                this_.$axios.get(url).then(function (result) {
                    //console.log("+++++")
                   // console.log(result)
                   // console.log(this_.objId)
                  if(result.data.code != 0){
                    this_.talkOBJ = result.data.response;
                    this_.objLink = encodeURIComponent("http://www.renrendonghua.com/activities/matchs/detail?id="+this_.objId);
                    this_.shareTitle = "活动分享_" + result.data.response.activityName
                    this_.posterUrl = "http://www.renrendonghua.com/postactivitypost/postactivity-v1?id=" + this_.objId + "&tem=" + new Date().getMilliseconds();
                    this_.sharePic=result.data.response.posterImage;
                    if(this_.objSelf){
                      this_.likeCountNum = this_.talkOBJ.likeCount
                      this_.shareCountNum = this_.talkOBJ.shareCount
                    }
                  }

                })
            }
            //是否加载页面显示
            if (this.loadShow) {
                this.showFirPL = true
            }
            this.getFatherForTwo();
            this.getShareData()
        },
        //发布父留言
        submitFather() {
            let this_ = this

            if (this_.formFather.commentContent.trim() == '') {
                this_.$notify({
                    title: "留言不能为空",
                    type: 'error',
                    showClose: false,
                    duration: 2000
                })
                return false;
            }

            this_.formFather.commentAuthor = this_.loginUserId
            commentApi.update(this_.formFather).then(re => {
                if(re.code==1){
                    this_.addCommentNum();

                    this_.formFather.commentContent=''
                    this_.$notify({
                        title: re.message,
                        type: 'success',
                        showClose: false,
                        duration: 2000
                    })


                    this_.reloadTalkPark()
                    this_.getFatherForTwo();
                } else {
                    this_.$notify({
                        title: re.message,
                        type: 'error',
                        showClose: false,
                        duration: 2000
                    })
                }

                //this_.pinglunEvent()
            })
        },
        pinglunEvent() {
            this.showFirPL = !this.showFirPL
            // //第一次查询
            // if(this.isFirst ){
            //   this.getFather()
            // }
            // this.showFirPL2 = false

        },
        share() {
            if(this.isLogin){
                this.dialogVisibleShare = true
            }else{
                window.location.href="http://www.renrendonghua.com/"+ this.callbackurl;
            }
        },
        shareMy() {
            let _this = this;
            _this.shareParam.shareTo = 1
            _this.shareParam.belongSection = _this.talkOBJ.belongSection
            if (_this.isLogin) {
                apiService.doshare(_this.shareParam).then(data => {
                    //console.log(data)
                    this.$message.success("成功分享到我的动态!");
                    this.dialogVisibleShare = false;
                    _this.initData();
                })
            } else {
                window.location.href="http://www.renrendonghua.com/"+_this.callbackurl;
            }
        },
        shareWechat() {
             let this_ = this
            this.dialogVisibleShareWechat = true
            // let objLink= "http://www.renrendonghua.com/worksdetail?id="+ this_.objId;
            // let objLink = this.objLink;
            let objLink= this.posterUrl;
            this.shareParam.shareTo = 2
            this.shareParam.belongSection = _this.talkOBJ.belongSection
            apiService.doshare(this.shareParam).then(data => {
                //console.log(data)
                this.$nextTick(() => {
                    document.getElementById("qrcode").innerHTML = "";
                    new this_.QRCode(this.$refs.qrcode, {
                        width: 100,
                        height: 100,
                        text: objLink
                    });
                })
            })

        },

        // sharePoster() {
        //     // let this_ = this
        //     this.dialogVisibleSharePoster = true
        //     let objLink = this.posterUrl;
        //     this.shareParam.shareTo = 2
        //     apiService.doshare(this.shareParam).then(data => {
        //         console.log(data)
        //         this.$nextTick(() => {
        //             document.getElementById("qrcodePoster").innerHTML = "";
        //             new QRCode(this.$refs.qrcodePoster, {
        //                 width: 100,
        //                 height: 100,
        //                 text: objLink
        //             });
        //         })
        //     })
        //
        // },
        shareWeibo() {
            this.shareParam.shareTo = 3
            this.shareParam.belongSection = _this.talkOBJ.belongSection
            apiService.doshare(this.shareParam).then(data => {
                //console.log(data)
                const url = this.objLink;
                const title = this.shareTitle;
                const pic = this.sharePic
                const appkey = '#_loginLayer_1578022321857'
                const link = `http://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=${pic}&appkey=${appkey}`
                window.open(link)
                this.dialogVisibleShare = false;

            })
        },
        shareQQzone() {
            this.shareParam.shareTo = 4
            this.shareParam.belongSection = _this.talkOBJ.belongSection
            apiService.doshare(this.shareParam).then(data => {
                //console.log(data)
                console.debug(this.objLink);
                const url = this.objLink;
                const title = this.shareTitle
                const desc = ''
                const summary = ''
                const site = ''
                const pic = this.sharePic
                const link = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${desc}&summary=${summary}&site=${site}&pics=${pic}`
                window.open(link)
                this.dialogVisibleShare = false;
            })
        },
        copyLink() {
            // apiService.doshare({"objectType": this.objType, "objectId": this.objId,"shareTo":6,"time": new Date().getMilliseconds()}).then(data => {
            let Url2 = decodeURIComponent(this.objLink);
            let oInput = document.createElement("input");
            oInput.value = Url2;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            oInput.className = "oInput";
            oInput.style.display = "none";
            this.$message.success("复制成功");
            this.dialogVisibleShare = false;
            // })
        },
        likeEvent(id,belongSection) {
            var _this = this;
            console.debug(_this.isLogin);
            if (_this.isLogin) {
                apiService.dolike({
                    "objectType": this.commentObjectType,
                    "objectId": id,
                    "belongSection":belongSection,
                    "time": new Date().getMilliseconds()
                }).then(data => {
                    //console.log(data)
                    _this.initData();
                    // _this.$parent.initData();
                })


            } else {
                window.location.href="http://www.renrendonghua.com/"+_this.callbackurl;
            }

        },
        disLikeEvent(id,belongSection) {
            var _this = this;
            if (_this.isLogin) {
                apiService.dislike({
                    "objectType": this.commentObjectType,
                    "objectId": id,
                    "belongSection":belongSection,
                    "time": new Date().getMilliseconds()
                }).then(data => {
                   // console.log(data)
                    _this.initData();
                    // _this.$parent.initData();
                })

            } else {
                window.location.href="http://www.renrendonghua.com/"+_this.callbackurl;
            }
        },
        jubao(id) {
            if(this.isLogin){
                this.currentDataId = id;
                this.dialogVisibleJubao = true
            }else{
                window.location.href="http://www.renrendonghua.com/"+ this.callbackurl;
            }
        },
        commitJubao() {
            var _this = this;
            this.dialogVisibleJubao = false;
            if (_this.isLogin) {
                if (this.jubaolist.length > 0) {
                    apiService.saveReport({
                        "objectType": this.objType,
                        "objectId": this.currentDataId,
                        "reportType": this.jubaolist[0]
                    }).then(data => {
                        //console.log(data);
                        _this.jubaolist = [];
                        _this.currentDataId = "";
                        _this.$message({
                            message: '举报成功',
                            type: 'info'
                        });
                        this.fullscreenLoading = false
                    })
                }
            } else {
                window.location.href="http://www.renrendonghua.com/"+_this.callbackurl;
            }
        },
        commitCollect(id) {
            var _this = this;
            if (_this.isLogin) {
                apiService.saveCollect({"objectType": this.objType, "objectId": id}).then(data => {
                    console.log(data);
                    _this.jubaolist = [];
                    _this.$message({
                        message: '成功加入收藏',
                        type: 'success'
                    });
                    this.fullscreenLoading = false
                })
            } else {
                window.location.href="http://www.renrendonghua.com/"+_this.callbackurl;
            }
        },
        toDetail(id) {
            // <!--                http://i.renrendonghua.com/#/articles/upload?id=17-->
            // <!--                http://i.renrendonghua.com/#/works/upload?id=40-->
            //console.log("this.objType====",this.objType)
            if (this.objType == 1) {
                window.open("http://i.renrendonghua.com/works/upload?id=" + id)
            } else if (this.objType == 2) {
                window.open("http://i.renrendonghua.com/articles/upload?id=" + id)
            } else if (this.objType == 3) {
                window.open("http://www.renrendonghua.com/activities/matchs/detail?id=" + id)
            }
        },
        toLog() {
            this.$router.push({
                path: '/login?callback=' + window.location.href,
            })

        },
        hideTalk(commentAuthorRankId) {
            if (commentAuthorRankId == 1) {
                this.isReloadV = false
            } else {
                this.isReload = false
            }
        },
        addCommentNum(){
            if(!this.objSelf){
                this.notify.commentCount = this.notify.commentCount+1
            }else{
                this.talkOBJ.commentCount = this.talkOBJ.commentCount+1
            }

        },
        delCommentNum(){
            if(!this.objSelf){
                this.notify.commentCount = this.notify.commentCount-1
            }else{
                this.talkOBJ.commentCount = this.talkOBJ.commentCount-1
            }
            this.getFatherForTwo()
        },
        reloadTalkPark(){
            let thiss = this
            // 移除组件
            thiss.isReload = false
            // 在组件移除后，重新渲染组件
            // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            thiss.$nextTick(() => {
                thiss.isReload = true
            })

            // 移除组件
            thiss.isReloadV = false
            // 在组件移除后，重新渲染组件
            // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            thiss.$nextTick(() => {
                thiss.isReloadV = true
            })
        },

        // //跳转详情页
        // toInfoPage(objType,objId){
        //   if(objType ==1){
        //     let routeData = this.$router.resolve({ path: '/worksdetail', query: {  id: objId } });
        //     window.open(routeData.href, '_blank');
        //     // this.$router.push({
        //     //   path:'/worksdetail',
        //     //   query: {id:objId}
        //     // })
        //   }
        //   if(objType ==2){
        //     let routeData = this.$router.resolve({ path: '/column/themedetail', query: {  id: objId } });
        //     window.open(routeData.href, '_blank');
        //     // this.$router.push({
        //     //   path:'/column/themedetail',
        //     //   query: {id:objId}
        //     // })
        //   }
        // }
        dropList() {
            this.showLike = !this.showLike
            if (this.showLike) {
                this.getLikeData()
            }
        },
        dropList1() {
            this.showShare = !this.showShare
            // if (this.showShare) {
            //     this.getShareData()
            // }
        },
        showAllUser() {
            // this.userListShow = this.userList
            this.showMore = true
        },
        getLikeData() {
            if (!this.nid) {
                return
            }
            let _this = this;
            let url = "/rrbi/notifications/getLikeList?id=" + _this.nid + "&ti=" + new Date().getMilliseconds();
            _this.$axios.get(url).then(function (result) {
                _this.userListLike = result.data.response
            })
        },
        getShareData() {
            if (!this.nid) {
                return
            }
            let _this = this;
            let url = "/rrbi/notifications/getShareList?id=" + _this.nid + "&ti=" + new Date().getMilliseconds();
            _this.$axios.get(url).then(function (result) {
                _this.userListShare = result.data.response
            })
        },

        getFather() {
            let this_ = this
            this_.commonParam.pageSize = 10
            commentApi.getPageList(this_.commonParam).then(reFather => {
                if(this_.commonParam.pageIndex == 1){
                    this_.commentListDate = []
                }

                reFather.list.forEach((item,index) => {
                    //console.log("item.id====",item.id)
                    // console.log(index)
                    index +1
                    this_.commentListDate.push(item)
                })

                this_.commentTotal = reFather.total
                if(this_.commonParam.pageIndex == Math.ceil(this_.commentTotal/this_.commonParam.pageSize)){
                    this_.commentShowMore =false
                }else{
                    this_.commonParam.pageIndex = this.commonParam.pageIndex +1
                }

            })
        },
        getFatherForTwo() {
            let this_ = this
            this_.commonParam.pageSize = 2
            this_.commonParam.pageIndex = 1
            commentApi.getPageList(this_.commonParam).then(reFather => {
                this_.commentListDate = []
                this_.commentTotal = 0
                reFather.list.forEach((item,index) => {
                    //console.log("item.id====",item.id)
                    // console.log(index)
                    index +1
                    this_.commentListDate.push(item)
                })
                this_.commentTotal = reFather.total
                if(this_.commentTotal <= 2){
                    this_.commentShowMore =false
                }else{
                    this_.commentShowMore =true
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
//@import "../../../assets/less/stylePublic.less";

.no-more {
  margin-top: 10px;
  font-size: 16px;
  text-align: center;
  line-height: 24px;
}
</style>
